import React from 'react';
import { Navigate } from 'react-router';
import ViolationPage from './components/ViolationPage';
import { APP_START_ROUTE, HIDE_SYSTEM_ROUTE } from '../../configs';

const routes = [
  {
    path: '/',
    element: <Navigate to={APP_START_ROUTE} replace />,
    weight: 1,
    hideOnMenu: HIDE_SYSTEM_ROUTE,
    permission: [],
    children: [],
    loginRequired: true,
    allowedRoles: [],
  },
  {
    path: APP_START_ROUTE,
    name: 'menu.violation',
    icon: 'card-checklist',
    // customIcon: true,
    loginRequired: true,
    component: ViolationPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
